import { render } from "./WelcomeComplex.vue?vue&type=template&id=6c2590fa"
import script from "./WelcomeComplex.vue?vue&type=script&lang=js"
export * from "./WelcomeComplex.vue?vue&type=script&lang=js"

import "./WelcomeComplex.vue?vue&type=style&index=0&id=6c2590fa&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__